// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { getQueryVariable, redirectToZendesk, getCountryCode } from '@/utils/common';
import Vue from 'vue';
import VueGtm from 'vue-gtm';
import App from './App';
import store from './store/index';

Vue.config.productionTip = false;

// This loads the FlowObject for use by other imports
store
  .dispatch('fetchSiteDetails')
  .then(() => {
    return Promise.all([store.dispatch('fetchFlowObject'), store.dispatch('fetchLocales')]);
  })
  .then(() => {
    var osRedirect = getQueryVariable('os_redirect');
    if (osRedirect) {
      redirectToZendesk();
    }
    return store.dispatch('fetchCategories');
  })
  .then(getCountryCode)
  .then(() =>
    Promise.all([import('./router'), import('@/plugins/i18n')]).then(([router, i18nPromise]) => {
      i18nPromise.default.then((i18n) => {
        // GTM (Vue-style)
        Vue.use(VueGtm, {
          id: 'GTM-TCVL28H',
          enabled: true,
        });
        /* eslint-disable no-new */
        new Vue({
          el: '#app',
          i18n: i18n,
          router: router.default,
          store: store,
          components: { App },
          template: '<App/>',
        });
      });
    })
  );
